import { Navigate, useLoaderData } from "react-router";
import { NavigationList } from "../../components/NavigationList";
import { BailleurItem } from "../../services/ApiService";
import { useApiService } from "../../contexts/ApiServiceContext";
import { Logger } from '../../utils/Logger';

export const BailleursPage = () => {
    const apiService = useApiService();

    if (apiService.isCurrentUserBailleur()) {
        Logger.debug('COMPONENT', "BailleursPage: current user is bailleur, redirecting");
        return <Navigate to={`/${apiService.getCurrentBailleurId()}`}/>
    }

    const data = useLoaderData() as { bailleurs: ReadonlyArray<BailleurItem> };
    Logger.debug('COMPONENT', "BailleursPage rendered with data:", data.bailleurs.length, "bailleurs");

    // Si on arrive ici, c'est forcément un utilisateur HandiToit
    const allBailleurs = [{ id: 0, nom: "- Hors bailleur -"}, ...data.bailleurs];
    return (
        <NavigationList items={allBailleurs.map(x => {
            return {
                text: x.nom,
                path: `../${x.id}`,
            };
        })} />
    );
};
